export const EndPoint = {
  HOTEL_MAIN: "/master/emt-hotel-proxy",
  HOTEL_LIST: "search",
  HOTEL_INFO: "hotelInfo",
  ROOM_INFO: "preBook",
  HOTEL_FILTER: "/RightFilter",
  HOTEL_BOOKING: "book",
  BOOKING_DETAILS: "bookingDetail", //check
  HOTEL_BOOKING_CANCEL: "cancel",
};
